import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

axios.defaults.withCredentials = true
Vue.prototype.axios=axios;
Vue.config.productionTip = false
Vue.prototype.Chart=Chart;


Vue.mixin({
  data: function() {
    return {

    }
  },
  computed: {
    nagykepernyo() {return this.$vuetify.breakpoint.name=='lg' || this.$vuetify.breakpoint.name=='xl'},
    kozepkepernyo() { return this.$vuetify.breakpoint.name=='lg' || this.$vuetify.breakpoint.name=='xl' || this.$vuetify.breakpoint.name=='md' || this.$vuetify.breakpoint.name=='sm'}
  },
  methods: {
    kijelentkezes: function() {
      router.push('/bejelentkezes');
      store.commit('minosites',0)
      store.commit('bejelentkezve', false)
    },
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
